<div *ngIf="loadingService.loading$ | async; let isLoading" [class.active]="isLoading" class="loading-indicator">
  <div class="loading-box">
    <div class="progress-symbol"></div>
    Bitte warten...
  </div>
</div>
